/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import LoadingButton from '@mui/lab/LoadingButton';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import dayjs, { Dayjs } from 'dayjs';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { IDatePeriod } from './utils';

const RangePicker = function ({
  open,
  setOpen,
  setRange,
  defaultRange,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  setRange: (from: Dayjs, to: Dayjs) => void;
  defaultRange?: IDatePeriod;
}) {
  const [calendarFrom, setCalendarFrom] = React.useState<Dayjs>(defaultRange?.dates?.start || null);
  const [calendarTo, setCalendarTo] = React.useState<Dayjs>(defaultRange?.dates?.end || null);
  const canSave = calendarFrom && calendarTo;

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    setRange(calendarFrom, calendarTo);
    setOpen(false);
  };

  return (
    <Dialog maxWidth="md" open={open} onClose={handleClose}>
      <DialogContent>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Stack direction="row" spacing={4}>
            <Stack direction="column" spacing={2}>
              <Typography align="center" variant="h6">
                Från datum
              </Typography>
              <StaticDatePicker
                displayStaticWrapperAs="desktop"
                value={calendarFrom}
                disableFuture
                minDate={dayjs().subtract(2, 'years')}
                onChange={(newValue) => {
                  setCalendarFrom(newValue);
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </Stack>
            <Stack direction="column" spacing={2}>
              <Typography align="center" variant="h6">
                Till datum
              </Typography>
              <StaticDatePicker
                displayStaticWrapperAs="desktop"
                value={calendarTo}
                disableFuture
                minDate={dayjs().subtract(1, 'years')}
                onChange={(newValue) => {
                  setCalendarTo(newValue);
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </Stack>
          </Stack>
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Avbryt</Button>
        <LoadingButton
          disabled={!canSave}
          data-test-id="apply-date-span"
          variant="contained"
          onClick={handleSave}
        >
          Spara
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

RangePicker.defaultProps = {
  defaultRange: null,
};

export default RangePicker;
